module.exports = __webpack_public_path__ + "static/media/TOC.b971bee5.png";